import type { UserPayload } from '@/store/types/UserPayload'
import { get } from '@/backend/api'
import type { ErrorWithMessage } from '@/backend/error/types'
import { isErrorResponse } from '@/backend/error/types'
import { errorMessages, parseError } from '@/backend/error'
import type { ApiResultNoValidationErrors } from './types'

export const loadProfile = async (): Promise<ApiResultNoValidationErrors<UserPayload>> => {
  try {
    const response = await get<UserPayload>('users/profile')
    return { data: response.data, ok: true }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    // this cannot be a validation error so it's safe to cast
    return {
      ...(parseError(error, errorMessages.PROFILE_LOAD) as { error: ErrorWithMessage }),
      ok: false,
    }
  }
}
